module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-en.813db24e.png";